<template>
    <div>
        <MainModal
            title="Rate card details" 
            :show-modal="showModal" 
            :footer="false" 
            size="md"
            @close="closeModal"
        >
            <template #body>
                <div class="rc__view__wrap" :class="{ 'disabled': downloadLoading }">
                    <template v-if="loading">
                        <PageSpinner />
                    </template>

                    <template v-else-if="noIdErr">
                        <EmptyPage state="error" />
                    </template>

                    <template v-else-if="loadingErr">
                        <EmptyPage state="error" @action="handleFetchRateCard" />
                    </template>

                    <template v-else>
                        <div>
                            <div class="">
                                <div class="flex justify-content-between align-items-baseline w-100">
                                    <div>
                                        <p class="rc__view__header">
                                            {{ currentItem.title }}
                                        </p>
                                        <span class="project__item__title text--normal mt--0 text--xs">
                                            Created on: {{ $format_date(currentItem.createdAt) }}
                                        </span>
                                    </div>
    
                                    <div class="flex align-items-center">
                                        <span 
                                            class="status__map text--medium text--xs tag bold badge rounded-pill mr--5" 
                                            :class="[rateTypeMap[currentItem.rateType]]"
                                        >
                                            <span class="status__circle" :class="[`${rateTypeMap[currentItem.rateType]}__text`]" />
                                            {{ $capitalize_first_letter(currentItem.rateType) }}
                                        </span>

                                        <DropDownButton 
                                            id="rateCardDownload" 
                                            prefix-icon 
                                            icon-name="download" 
                                            icon-width="16px"
                                            variant="outline" 
                                            label="Download" 
                                            size="sm"
                                        >
                                            <template #dropdown-content>
                                                <div class="flex justify-content-center">
                                                    <span class="tag bold text--xxs tag--grey mt--5">Coming soon!</span>
                                                </div>
                                                <!-- <ListItem 
                                                    v-for="temp in downloadTemplates" 
                                                    :key="temp.id" 
                                                    class="flex align-items-center" 
                                                    pointer 
                                                    @click="downloadCard(temp.name)"
                                                >
                                                    <IconSvg name="spreadsheet" width="16px" fill="#64748b" />
                                                    <span class="text--xs text-gray-800 ml--5">{{ temp.name }}</span>
                                                </ListItem> -->
                                            </template>
                                        </DropDownButton>
                                    </div>
                                </div>
    
                                <div class="mt--30">
                                    <FormLabel 
                                        label-type="menu" 
                                        html-for="description" 
                                        title="Memo" 
                                        class="text--sm mb--10 text--upper" 
                                    />
                                    <p class="rc__view__desc">
                                        {{ currentItem.description || '-' }}
                                    </p>
                                </div>
                            </div>
    
                            <div v-if="currentItem.socials && currentItem.socials.length" class="mt--30">
                                <FormLabel 
                                    label-type="menu" 
                                    html-for="socialItems" 
                                    title="Social accounts" 
                                    class="text--sm mb--10 text--upper" 
                                />
                                <CustomTable
                                    :columns="rateCardSocialHeaders" :is-checkbox="false"
                                    :data="currentItem.socials" table-type="striped" :is-action-btns="false"
                                >
                                    <template #rows="data">
                                        <td>{{ data.name || '-' }}</td>
                                        <td>
                                            {{ data.url || '-' }}
                                        </td>
                                    </template>
                                </CustomTable>
                            </div>
    
                            <div class="rc__view__total mt--30">
                                <div class="services-section">
                                    <div v-for="item in currentItem.items" :key="item._id" class="rc__service__card">
                                        <div class="rc__service__content">
                                            <div class="flex-1">
                                                <div class="service-name">
                                                    {{ item.serviceName || '-' }} <strong v-if="item.priceType">({{ item.priceType }})</strong>
                                                </div>
                                                <div class="service-description">
                                                    {{ item.rateType || "-" }}
                                                </div>
                                            </div>
                                            <div class="service-price">
                                                {{ $country.getSymbol(currentItem.currency, 'currency') }}{{ $format_amount(item.amount, 2) }}
                                            </div>
                                            <div class="service-total text--capitalize">
                                                {{ item.priceType }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
            <template #footer>
                <div class="w-100 flex justify-content-end align-items-center">
                    <BaseButton label="Close" @submit="closeModal" />
                </div>
            </template>
        </MainModal>
    </div>
</template>

<script>
import BaseButton from "../buttons/BaseButton.vue";
import MainModal from "./MainModal.vue";
import PageSpinner from "../loaders/PageSpinner.vue";
import EmptyPage from "../emptyPage/EmptyPage.vue";
import IconSvg from "../icons/Icon-Svg.vue";
import { MAX_COUNT_BY_FEATURES, rateTypeMap } from "@/utils/enums";
import CustomTable from "../tables/index.vue";
import { rateCardSocialHeaders, rateCardServiceHeaders } from "@/utils/dummy";
import FormLabel from "../forms/FormLabel.vue";
import DropDownButton from "../buttons/DropDownButton.vue";

export default {
    name: "ViewRateCard",

    components: { 
        MainModal, 
        BaseButton, 
        PageSpinner, 
        EmptyPage, 
        CustomTable, 
        FormLabel,
        DropDownButton,
        IconSvg,
    },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },

        cardId: {
            type: String,
            default: "",
        },
    },

    emits: ["close", "show-upgrade-modal"],

    data() {
        return {
            loading: false,
            loadingErr: false,
            noIdErr: false,
            currentItem: {
                title: "",
                items: [],
                rateType: "",
                currency: "",
                createdAt: null,
            },
            downloadLoading: false,
            rateTypeMap, 
            rateCardSocialHeaders, 
            rateCardServiceHeaders,
            downloadTemplates: [
                { id: "template11", name: "Template1.1" },
                { id: "template12", name: "Template1.2" },
                { id: "template21", name: "Template2.1" },
                { id: "template22", name: "Template2.2" },
            ],
        };
    },

    computed: {
        userProfile() {
            return this.$store.getters["auth/profile"];
        },

        accountPlan() {
            return this.$store.getters["subscription/subscriptionInfo"]?.plan || "free";
        },

        rateCardDownloadCount() {
            return this.$store.getters["auth/profile"]?.downloadCount || 0;
        },
    },

    watch: {
        "cardId": {
            async handler(newVal) {
                if (!newVal) {
                    this.noIdErr = true;
                } else {
                    await this.handleFetchRateCard();
                }
            },
            immediate: true,
        },
    },

    methods: {
        async downloadCard(template) {
            try {
                if (["standard", "free"].includes(this.accountPlan)) {        
                    const maxLimit = MAX_COUNT_BY_FEATURES[this.accountPlan].downloadCount;
        
                    if (maxLimit !== 0 && this.userProfile?.downloadCount >= maxLimit) {
                        this.$emit("show-upgrade-modal", { bool: true, type: "download" });
                        return;
                    }    
                }

                this.downloadLoading = true;

                const resp = await this.$store.dispatch("ratecards/downloadRateCard", { 
                    id: this.currentItem._id,
                    config: {
                        responseType: "blob",
                        headers: {
                            "Accept": "application/pdf",
                        },
                    },
                    template: template,
                });

                const blob = new Blob([resp.data], { type:  "application/pdf" });

                if (!blob || blob.size === 0) {
                    console.warn("Blob size:", blob.size);
                    throw new Error("PDF file is empty");
                }

                const url = window.URL.createObjectURL(blob);

                console.log({ url });
    
                // Create link element
                const link = document.createElement("a");
                link.href = url;
                
                // Get filename from response headers or set default
                const contentDisposition = resp.headers["content-disposition"];
                // const fileName = contentDisposition
                //     ? contentDisposition.split("filename=")[1].replace(/"/g, "")
                //     : "rate_card.pdf";

                let fileName = "rate_card.pdf";
                
                if (contentDisposition && contentDisposition.includes("filename=")) {
                    const match = contentDisposition.match(/filename="?([^\";]+)"?/);
                    fileName = match ? match[1] : fileName;
                }
                
                link.setAttribute("download", fileName);
                
                // Append link to body
                document.body.appendChild(link);
                
                // Start download
                link.click();
                
                // Clean up
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);
             
                this.$toast.success("Rate card downloaded");
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;                
                this.$toast.error(errMsg);
            } finally {
                this.downloadLoading = false;
            }
        },

        async handleFetchRateCard() {
            try {
                this.noIdErr = false;
                this.loadingErr = false;
                this.loading = true;

                const res = await this.$store.dispatch("ratecards/fetchRateCard", this.cardId);

                this.currentItem = {
                    ...this.currentItem,
                    ...res,
                };
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;
                this.loadingErr = true;
            } finally {
                this.loading = false;
            }
        },

        closeModal() {
            this.$emit("close");
            
            this.currentItem = {
                title: "",
                items: [],
                rateType: "",
                currency: "",
                createdAt: null,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.rc {
    &__view {
        &__header {
            &__date {
                color: #38393b;
                font-size: 0.875rem;
                margin-left: 5px;
            }

            &__type {
                color: #38393b;
                font-size: 14px;
                text-transform: capitalize;
                margin-top: 5px;
            }

            &__download {
                border-radius: 5px;
                padding: 5px 8px;
                background: #eee;
                cursor: pointer;
            }
        }

        &__row {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            width: 100%;
            justify-content: flex-end;

            &__text {
                font-size: 0.875rem;
                font-weight: 600;
                text-transform: uppercase;
                margin-left: 10px;
            }
        }

        &__total {
            margin-bottom: 25px;
        }
    }
}
</style>